import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BluetoothConnectedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bluetooth_connected"}/>
}
